import React, { useEffect, useState } from 'react';
import './UserDashboard.css';
import { Link } from 'react-router-dom';
import UserDashboardMenu from './UserDashboardMenu';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../firebase.init';
import HeaderBottom from '../components/HomePage/HeaderBottom';
import { signOut } from 'firebase/auth';
import MarginTop from '../MarginTop';

const UserDashboard = () => {
    const [user] = useAuthState(auth);
    const [orders, setOrders] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [ordersPerPage] = useState(3);

    useEffect(() => {
        fetch(`https://aprilone-178ea8362c0b.herokuapp.com/orders`)
            .then((res) => res.json())
            .then((info) => setOrders(info.reverse()))
            .catch((error) => console.error('Error fetching orders:', error));
    }, []);

    const handleSignout = () => {
        signOut(auth);
    };

    // Pagination Logic
    const indexOfLastOrder = currentPage * ordersPerPage;
    const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
    const currentOrders = orders
        .filter(order => order.customerEmail === user?.email)
        .slice(indexOfFirstOrder, indexOfLastOrder);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    return (
        <>
            <HeaderBottom />



            <section id="services" className="services-area pt-120 pb-90 fix mb-5">
                <div className="container ">
                    <div className="text-center mb-4">
                        <div className='d-flex justify-content-center'><Link className="button-professional" onClick={handleSignout}>Signout</Link></div>

                        <h2 className='one-head'>Welcome to User Dashboard</h2>
                    </div>

                    <UserDashboardMenu />

                    <div className="text-center mb-4">
                        <h2>My Orders</h2>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-striped table-hover table-bordered border-light text-center">
                            <thead className="table-light">
                                <tr>
                                    <th scope="col">Sl No.</th>
                                    <th scope="col">Order Date</th>
                                    <th scope="col">Your Name</th>
                                    <th scope="col">Amount</th>
                                    <th scope="col">Order Status</th>
                                    <th scope="col">Payment Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {currentOrders.map((order, index) => (
                                    <tr key={order._id}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{order.orderDate}</td>
                                        <td>{order.customerName}</td>
                                        <td className="fw-bold">${order.packagePrice}</td>
                                        <td>
                                            <span className={`badge ${order.orderStatus === "Completed" ? "bg-success" : "bg-warning"} p-2`}>
                                                {order.orderStatus}
                                            </span>
                                        </td>
                                        <td>
                                            {order.paymentStatus === "UnPaid" && (
                                                <Link className="btn btn-primary btn-sm text-white fw-bold" to={`/pay-now/${order._id}`}>
                                                    <i className="fas fa-credit-card me-1"></i> Pay Now
                                                </Link>
                                            )}
                                            {order.paymentStatus === "Paid" && (
                                                <span className="badge bg-success p-2">
                                                    <i className="fas fa-check-circle me-1"></i> Paid
                                                </span>
                                            )}
                                            {order.paymentStatus === "Cancelled" && (
                                                <>
                                                    <span className="badge bg-danger p-2">
                                                        <i className="fas fa-times-circle me-1"></i> Cancelled
                                                    </span>
                                                    <Link
                                                        className="btn btn-outline-warning btn-sm fw-bold rounded-pill m-1"
                                                        to={`/pay-now/${order._id}`}
                                                    >
                                                        <i className="fas fa-credit-card me-1"></i> Retry Payment
                                                    </Link>
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>



                    {/* Bootstrap Pagination for Orders */}
                    <nav aria-label="Orders Page Navigation paragraph">
                        <ul className="pagination justify-content-center paragraph">
                            {/* Previous Button */}
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                <button
                                    className="page-link paragraph"
                                    onClick={() => paginate(currentPage - 1)}
                                    disabled={currentPage === 1}
                                >
                                    <i className="fas fa-chevron-left me-1 "></i> Previous
                                </button>
                            </li>

                            {/* Page Numbers */}
                            {Array.from({ length: Math.ceil(orders.filter(order => order.customerEmail === user?.email).length / ordersPerPage) }, (_, i) => (
                                <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                                    <button
                                        className="page-link fw-bold paragraph"
                                        onClick={() => paginate(i + 1)}
                                    >
                                        {i + 1}
                                    </button>
                                </li>
                            ))}

                            {/* Next Button */}
                            <li className={`page-item ${currentPage === Math.ceil(orders.filter(order => order.customerEmail === user?.email).length / ordersPerPage) ? 'disabled' : ''}`}>
                                <button
                                    className="page-link paragraph"
                                    onClick={() => paginate(currentPage + 1)}
                                    disabled={currentPage === Math.ceil(orders.filter(order => order.customerEmail === user?.email).length / ordersPerPage)}
                                >
                                    Next <i className="fas fa-chevron-right ms-1"></i>
                                </button>
                            </li>
                        </ul>
                    </nav>

                </div>
            </section>


        </>
    );
};

export default UserDashboard;
